export default __webpack_public_path__ + "static/media/373.9af95a65.jpg";